import { useState } from "react";
import SessionPreferencesContext, {
    SessionPreferencesContextType,
} from "./SessionPreferencesContext";

const SessionPreferencesProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const [fieldsFilter, setFieldsFilter] = useState<
        SessionPreferencesContextType["fieldsFilter"]
    >({
        accountManager: null,
        csp: null,
        farm: null,
        search: null,
    });
    const [homeFilters, setHomeFilters] = useState<
        SessionPreferencesContextType["homeFilters"]
    >({
        globalFilter: null,
        columnFilters: [],
    });

    return (
        <SessionPreferencesContext.Provider
            value={{
                fieldsFilter,
                setFieldsFilter,
                homeFilters,
                setHomeFilters,
            }}
        >
            {children}
        </SessionPreferencesContext.Provider>
    );
};

export default SessionPreferencesProvider;
